import LocationNode from './location-node.connect'

export default LocationNode
